import React from 'react';
import './Benefits.scss';

const Benefits: React.FC = () => {
  const benefits = [
    {
      id: 1,
      title: 'Controle financeiro completo',
      description: 'Organize vendas, contas, fluxo de caixa e recebimentos em um único lugar — sem depender de planilhas ou anotações.',
      icon: 'chart-line',
      size: 'medium'
    },
    {
      id: 2,
      title: 'Automação que economiza tempo',
      description: 'Lançamentos automáticos e integrações reduzem retrabalho e deixam sua rotina mais leve.',
      icon: 'bolt',
      size: 'medium'
    },
    {
      id: 3,
      title: '100% Customizável para seu negócio',
      description: 'Podemos adaptar o sistema e desenvolver funcionalidades específicas para atender às necessidades da sua empresa.',
      icon: 'cogs',
      size: 'medium'
    },
    {
      id: 4,
      title: 'Decisões baseadas em dados',
      description: 'Dashboards e relatórios mostram quanto entra, sai e quais produtos dão lucro — sem complexidade.',
      icon: 'chart-pie',
      size: 'medium'
    },
    {
      id: 5,
      title: 'Gestão profissional e integrada',
      description: 'Estoque, vendas e financeiro funcionam integrados, evitando bagunça e perda de informações.',
      icon: 'building',
      size: 'medium'
    },
    {
      id: 6,
      title: 'Simples e fácil de usar',
      description: 'Sistema direto, sem complicação. Feito para quem não tem tempo de aprender ferramentas complexas.',
      icon: 'rocket',
      size: 'medium'
    }
  ];

  return (
    <section className="benefits" id='beneficios'>
      <div className="benefits-container">
        <div className="benefits-header">
          <h2>Como o 77Gestão transforma sua rotina</h2>
          <p>Tudo que você precisa para gerenciar seu negócio com profissionalismo</p>
        </div>
        
        <div className="benefits-grid">
          {benefits.map((benefit) => (
            <div key={benefit.id} className={`benefit-card benefit-${benefit.size}`}>
              <div className="benefit-header">
                <div className="benefit-icon">
                  <i className={`fas fa-${benefit.icon}`}></i>
                </div>
                <h3>{benefit.title}</h3>
              </div>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
